import { FormNotifications, GearInstance, StepperStep } from '../../../types';
import { Dispatch } from 'react';
import { SnackbarProps } from '../../../components/Snackbar';
import { getCommonFormProps } from './commonData';
import { getSolidPriceErrorMessage } from '../../../utils/validators';


export const getSellPricingStep = (
  instance: GearInstance,
  onPass: (data: any, toDraft?: boolean) => void,
  acceptOffers: boolean,
  minOfferPercent: number,
  coverShippingAllowed: boolean,
  notifications: Record<string, FormNotifications>,
  setSnackNotification: Dispatch<SnackbarProps>,
): StepperStep => {
  return {
    stepName: 'Pricing',
    onPass: async (data: any) => {
      if(data.price)
        onPass(data);
      else {
        setSnackNotification({
          header: 'Price field is required',
          mode: 'error'
        })
      }

    },
    formProps: {
      notifications: notifications,
      buttonCaption: 'Next',
      ...getCommonFormProps(onPass),
      fields: [
        {
          type: 'secondTitle',
          fieldName: 'step_title',
          value: 'Pricing',
        },
        {
          type: 'template',
          gridColumns: 'grid_1_1bottom',
          fields: [
            {
              type: 'number',
              fieldName: 'price',
              label: `Price (${instance.currency})`,
              placeholder: 'Sale Price *',
              isThin: true,
              value: instance.price ? instance.price : undefined,
              prefix: '$',
              validator: getSolidPriceErrorMessage,
              required: true,
            },
            {
              type: 'number',
              fieldName: 'original_price',
              placeholder: 'Original Price',
              isThin: true,
              value: instance.original_price ? instance.original_price : undefined,
              prefix: '$',
              validator: getSolidPriceErrorMessage,
            },
          ],
        },
        {
          type: 'description',
          value: 'SENDY takes advertisement fee.'
        },
        {
          type: 'charityCheckbox',
          label: "Donate earnings to charity of the month",
          fieldName: 'charity',
          checked: instance.charity_percent===100,
        },
        {
          type: 'separator',
        },
        ...(!coverShippingAllowed ? [] : [
          {
            type: 'formSwitch',
            placeholder: 'Cover shipping costs',
            fieldName: `cover_shipping_enabled`,
            mode: 'switch',
            value: !!(instance.cover_shipping_enabled),
            isRequired: false,
            fields: [
              {
                type: 'number',
                fieldName: 'cover_shipping_to',
                placeholder: 'Maximum shipping coverage',
                isThin: true,
                value: instance.cover_shipping_to,
                prefix: '$',
              },
              {
                type: 'description',
                value: `If the shipping cost exceeds this amount, the buyer will cover the difference. Leave blank for no limit.`
              },
            ]
          },
        ]),
        {
          type: 'formSwitch',
          placeholder: 'Allow buyers to send offers',
          fieldName: `offer_allowed`,
          mode: 'switch',
          value: !!(acceptOffers && instance.offer_allowed),
          isDisabled: !acceptOffers,
          isRequired: false,
          fields: [
            {
              type: 'number',
              fieldName: 'min_offer_price_percent',
              placeholder: 'Minimum offer',
              isThin: true,
              value: instance.min_offer_price_percent,
              prefix: '%',
            },
            {
              type: 'description',
              value: `By default the minimum offer value that buyer can send is ${minOfferPercent}% of the sale price. Leave it blank if you don’t want to overwrite this setting.`
            },
            {
              type: 'number',
              fieldName: 'auto_accept_offer_from',
              placeholder: 'Auto-accept threshold',
              isThin: true,
              value: instance.auto_accept_offer_from,
              prefix: '$',
            },
            {
              type: 'description',
              value: 'Offers meeting or exceeding the auto-accept threshold will be accepted automatically. Leave it blank if you don’t want to auto-accept offers.'
            },
          ]
        },
      ...(acceptOffers ? [] : [
        {
          type: 'description',
          fieldName: 'warning',
          value: 'You have disabled the ability to receive offers. You can update this preference in your Account Settings.',
        },
      ]),
      ],
    },
  };
};
